import { BaseApi } from "../base";

export default class AttachmentApi extends BaseApi {
  protected readonly prefix = "chats";

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  private updateSafetyConfirmation = (fileName: string, chatId: string, isSafetyConfirmed: boolean) =>
    this.put(`${chatId}/attachment/${fileName}`, { safety_confirmation: isSafetyConfirmed ? "1" : "0" });

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  allow = (fileName: string, chatId: string) => this.updateSafetyConfirmation(fileName, chatId, true);
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  deny = (fileName: string, chatId: string) => this.updateSafetyConfirmation(fileName, chatId, false);
}
